import { Component, Input, OnInit } from '@angular/core';
import { TYPE_PRODUCT } from 'app/core/models/constans.model';
import { Item, Menu } from 'app/menu/models/menu.model';
import { MenuService } from 'app/menu/services/menu.service';
import { LangComponent } from '../lang/lang.component';

@Component({
    selector: 'app-type-product',
    templateUrl: './type-product.component.html',
    styleUrls: ['./type-product.component.scss'],
    standalone: false
})
export class TypeProductComponent extends LangComponent implements OnInit {
  /**
   * Informacion del menu para sacar colores y tipo de fuente
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Informacion del item
   */
  @Input() item: Item = {} as Item;
  /**
   * Color personalizado
   */
  @Input() color: string | undefined;
  TYPE_PRODUCT = TYPE_PRODUCT;
  constructor(
    public menuService: MenuService
  ) {
    super(menuService);
  }

  ngOnInit(): void {
    if (this.color) {
      this.menu.colorText = this.color;
    }
  }

}
